import React from 'react';
import { Icon } from 'ui';
import DataCardTitle from './Title';

class DataCardHeader extends React.Component {
  render() {
    const { children, subtitle, title, tooltip, downloadLink, reportTitle } =
      this.props;

    return (
      <header className="DataCard-header">
        {children && children}
        <DataCardTitle title={title} tooltip={tooltip} subtitle={subtitle} />
        {downloadLink && (
          <div>
            <hr className="SlimRule" />
            <a href={downloadLink} className="DataCard-link">
              <Icon name="download" /> {reportTitle}
            </a>
          </div>
        )}
      </header>
    );
  }
}

export default DataCardHeader;
